export enum VideoTab {
  DstVideo = 'dstVideo',
  LipSyncVideo = 'lipSyncVideo',
  SrcVideo = 'srcVideo',
  VisualTranslation = 'visualTranslation',
}

// The dubbed video with its on-screen text translated, when the project can have one.
export type VisualTranslationVideo = {
  // Set when the tab plays a draft (the agent is still working, or the run failed after it): not the final result.
  draft?: { downloadUrl: string; number: number } | null;
  isInProgress: boolean;
  // Set when the plan has no on-screen text translation: why the download is unavailable.
  lockedMessage?: string;
  url: null | string;
};
